import React from 'react';
import Page504 from 'assets/img/504.png';

function ErrorPage() {
  return (
    <div className="wrapper" style={{ backgroundColor: 'white' }}>
      <div className="main">
        <div className="container-fluid p-0 h-100">
          <div
            className="d-flex justify-content-center align-items-center my-auto h-100"
            style={{ margin: '0 auto', flexDirection: 'column' }}
          >
            <img className="" src={Page504} alt="" style={{ width: '20%' }} />
            <a href="/">Back to home</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
